<form [formGroup]="supportForm" class="dashboard-tile" style="width:600px; height:600px; box-sizing:content-box;">
  <div class="tile-header">
    <div class="tile-header-title">Upgrade</div>
  </div>
  <div class="tile-content">
    <div class="formFieldList" style="height: calc(100% - 41px);">
      <div style="padding-top: 20px; padding-bottom: 30px;">Please submit your contact information and an account manager will be in contact to get your trial converted.</div>
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="email" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Phone" formControlName="phone" required>
      </mat-form-field>
    </div>
    <div class="tile-footer centered">
      <button class="mat-raised-button mat-primary" (click)="send()">Submit</button>
      <button class="mat-raised-button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</form>
